/// <amd-module name="Wit/ClientWorkItemService/SerialPromiseQueue" />

export class SerialPromiseQueue<T = unknown> {
    private q: (() => Promise<T>)[] = [];

    private currentPromise: Promise<T> | undefined = undefined;

    queue(operation: () => Promise<T>): void {
        this.q.push(operation);
        this.drainQueue();
    }

    private async drainQueue(): Promise<void> {
        if (this.currentPromise) {
            return;
        }

        for (const operation of this.q) {
            try {
                this.currentPromise = operation();
                await this.currentPromise;
            } catch (e: unknown) {
                throw e;
            } finally {
                this.currentPromise = undefined;
            }
        }

        this.q = [];
    }
}
